import React, { memo, useState } from 'react';
import { ChevronRight } from 'react-feather';
import classNames from 'classnames';
import ReactTooltip from 'react-tooltip';
import { smallDate } from '../../utils/constants';
import { ThumbsUp, ThumbsDown } from 'react-feather';
import FeedbackForm from '../rootcause/feedbackForm';
import parse from 'html-react-parser';
import { HTMLremover } from './../../utils/commonFunctions';

const AnomalyCard = (props) => {
  let { kpi_name, inference, owner, anomaly_id } = props.anomaly;
  let { severity, status, aan_date, liked } = props.anomaly;
  let { id, onSelect, anomaly, updateAnomaly } = props;
  const [modalShow, setModalShow] = useState(false);
  let date = new Date(aan_date).toLocaleString(undefined, smallDate);

  let severityClass = classNames('fa', 'fa-circle', severity.toLowerCase());
  let statusClass = classNames('m-0', status.toLowerCase().replace(' ', '-'));
  let anomalyCardClass = classNames(
    'd-flex',
    'anomalyCard',
    anomaly_id === id ? 'active' : ''
  );

  //Function 2: Feedback Update
  const feedbackUpdate = async (liked) => {
    let aan_data = { ...anomaly };
    aan_data.liked = aan_data.liked === liked ? null : liked;
    updateAnomaly(aan_data);
    if (aan_data.liked !== null && aan_data.liked === false) setModalShow(true);
  };

  //Function 3: Submit feedback comments
  const sumbitFeedbackComment = async (data) => {
    updateAnomaly(data);
    setModalShow(false);
  };

  const feedbackThumbs = (
    <div className='feedbackThumbs flex-fill'>
      <ThumbsDown
        size={16}
        className={`mr-2 thumbsdown ${
          !liked && liked !== null ? 'active' : ''
        }`}
        onClick={() => feedbackUpdate(false)}
      />
      <ThumbsUp
        size={16}
        className={`mr-2 thumbsup ${liked ? 'active' : ''}`}
        onClick={() => feedbackUpdate(true)}
      />
    </div>
  );

  return (
    <div key={props.index} className={anomalyCardClass}>
      <div className='d-flex cardInner' onClick={() => onSelect(anomaly)}>
        <div className='anomalyDetails'>
          <div className='anomalyTitle'>
            <i className={severityClass}></i>
            <p className='m-0 mr-1'>{kpi_name}</p>
            <p className={statusClass}>{status}</p>
          </div>
          <p className='anomalyDescription'>{parse(HTMLremover(inference))}</p>
          <div className='d-flex align-items-center mt-2'>
            <p className='anomalyOwner m-0'>{owner}</p>
            {feedbackThumbs}
            <p className='anomalyDate m-0 text-right'>{date}</p>
          </div>
        </div>
        <div className='selectAnomaly'>
          <ChevronRight />
        </div>
      </div>
      <ReactTooltip type='light' effect='solid' id='liked' />
      <FeedbackForm
        show={modalShow}
        onHide={() => setModalShow(false)}
        data={anomaly}
        submitdata={(data) => sumbitFeedbackComment(data)}
        type='alert'
      />
    </div>
  );
};

export default memo(AnomalyCard);

/* {liked && (
              <Heart
                className="flex-fill anomalylike"
                data-tip="You liked this alert"
                data-for="liked"
              />
            )} */
